import type { GetUserActivityRow } from '@morfi/backend-sdk-v2/client';
import type { IconSvgElement } from '@/components/ui/icon';
import {
  Coins01IconSolid,
  FlashIconSolid,
  GiftIconSolid,
  MinusSignCircleIconSolid,
  PlusSignCircleIconSolid,
  SparklesIconSolid,
} from '@/components/ui/icon/glyphs';

export type ActivityFilter = 'buys' | 'sells' | 'backings' | 'boosts' | 'claims' | 'gifts';

export const ACTIVITY_ICONS: Readonly<Record<ActivityFilter, IconSvgElement>> = {
  buys: PlusSignCircleIconSolid,
  sells: MinusSignCircleIconSolid,
  backings: Coins01IconSolid,
  boosts: FlashIconSolid,
  claims: SparklesIconSolid,
  gifts: GiftIconSolid,
};

export const ACTIVITY_KINDS: Readonly<Record<ActivityFilter, string>> = {
  buys: 'trade',
  sells: 'trade',
  backings: 'back,unback',
  boosts: 'boost',
  claims: 'claim,claim_backer_fees',
  gifts: 'gift_sent,gift_received',
};

export function matchesActivityFilter(
  row: {
    kind: GetUserActivityRow['kind'] | undefined;
    side: GetUserActivityRow['side'] | undefined;
  },
  filter: ActivityFilter | undefined,
): boolean {
  switch (filter) {
    case 'buys':
      return row.kind === 'trade' && row.side === 'buy';
    case 'sells':
      return row.kind === 'trade' && row.side === 'sell';
    case 'backings':
      return row.kind === 'back' || row.kind === 'unback';
    case 'boosts':
      return row.kind === 'boost';
    case 'claims':
      return row.kind === 'claim' || row.kind === 'claim_backer_fees';
    case 'gifts':
      return row.kind === 'gift_sent' || row.kind === 'gift_received';
    case undefined:
      return true;
  }
}
